import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GTM_ID = process.env.REACT_APP_GTM_ID || "GTM-WXHNM2J";
const GTM_SCRIPT_ID = "gtm-script";

function initializeGtm() {
  if (!GTM_ID || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  // Prevent duplicate script injection in React StrictMode/dev rerenders.
  if (!document.getElementById(GTM_SCRIPT_ID)) {
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js"
    });

    const script = document.createElement("script");
    script.id = GTM_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
  }
}

export function trackGtmEvent(eventName, payload = {}) {
  if (!eventName || typeof window === "undefined") {
    return;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    event: eventName,
    ...payload
  });
}

export default function GtmProvider({ children }) {
  const location = useLocation();

  useEffect(() => {
    initializeGtm();
  }, []);

  useEffect(() => {
    trackGtmEvent("page_view", {
      page_path: `${location.pathname}${location.search}${location.hash}`,
      page_title: document.title,
      page_location: window.location.href
    });
  }, [location.pathname, location.search, location.hash]);

  return <>{children}</>;
}
